export default __webpack_public_path__ + "static/media/Desk.f8263a9c.svg";